package com.fireavert.devices.data_models.data_model

enum class StatusLevel {
    Green,
    Yellow,
    Red,
    Grey,
    None
}